"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPronunciationDictionaryMetadataResponseModelPermissionOnResource = void 0;
exports.GetPronunciationDictionaryMetadataResponseModelPermissionOnResource = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
